const getParapheurUrl = (parapheur: string): string => {
	if (parapheur.startsWith('-pp')) {
		return `https://parapheur${parapheur}.jvsonline.fr/`;
	}

	return `https://parapheur${parapheur}.jvs-mairistem.fr/`;
};

export default getParapheurUrl;
